export const STATUS_OPTIONS: { value: boolean; label: string }[] = [
  {
    value: false,
    label: 'Не активный',
  },
  {
    value: true,
    label: 'Активный',
  },
];

export const STATUS_FILTER_OPTIONS: { value: boolean | null; label: string }[] = [
  {
    value: null,
    label: 'Все',
  },
  ...STATUS_OPTIONS.reverse(),
];
